module.exports = __webpack_public_path__ + "static/media/domino2-color.c303eeca.jpg";